import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Badge } from "@/components/ui/badge";
import { FileCheck2 } from "lucide-react";

export function FormSelectionStep({ value, onChange, catalog }) {
  const { t, lang } = useLanguage();
  return (
    <div className="space-y-6" data-testid="step-form-selection-content">
      <div>
        <h2 className="text-3xl font-black tracking-tight md:text-4xl">
          {t.form_selection.title}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {t.form_selection.description}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {catalog.map((f) => {
          const selected = value === f.code;
          const title = lang === "es" ? f.title_es : f.title_pt;
          const desc = lang === "es" ? f.description_es : f.description_pt;
          return (
            <button
              key={f.code}
              type="button"
              data-testid={`form-option-${f.code}`}
              onClick={() => onChange(f.code)}
              className={`group relative flex flex-col gap-3 border p-5 text-left transition-colors ${
                selected
                  ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))]/[0.03]"
                  : "border-border bg-card hover:border-foreground/30"
              }`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
                  USCIS
                </span>
                {selected && (
                  <FileCheck2
                    className="h-4 w-4 text-[hsl(var(--primary))]"
                    strokeWidth={2.5}
                  />
                )}
              </div>
              <div>
                <div className="text-2xl font-black tracking-tight">
                  {f.code}
                </div>
                <div className="mt-1 text-sm font-medium leading-snug">
                  {title}
                </div>
              </div>
              <p className="text-xs leading-relaxed text-muted-foreground">
                {desc}
              </p>
              <div className="flex flex-wrap gap-1.5 pt-1">
                {f.categories.map((c) => (
                  <Badge
                    key={c}
                    variant="secondary"
                    className="rounded-none border border-border bg-card font-mono text-[9px] uppercase tracking-widest text-muted-foreground"
                  >
                    {c}
                  </Badge>
                ))}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
